module.exports = __webpack_public_path__ + "img/ringProfile@2x.96814d7.webp";